export enum SlideInMenuVariant {
  compact,
  expanded,
}

export const slideInMenuPrefix = 'dropdown-menu';
export const slideInMenuPrefixWithHash = `#${slideInMenuPrefix}`;

export const cssTransitionClassNames = 'tab-content-animation';
